import { useEffect, useState } from 'react'

import { authenticate, type AuthResult } from '../api/auth'
import { setAccessToken } from '../api/client'
import { createBrowserBridge } from '../bridge/browserBridge'
import { createMessengerBridge, type MessengerBridge } from '../bridge'
import { installPreviewApi, isPreviewMode, previewSession } from '../preview/preview'

type AuthState =
  | { status: 'loading' }
  | { status: 'ready'; bridge: MessengerBridge; auth: AuthResult }

export const useMiniAppAuth = (): AuthState => {
  const [state, setState] = useState<AuthState>({ status: 'loading' })

  useEffect(() => {
    const run = async () => {
      if (isPreviewMode()) {
        installPreviewApi()
        setAccessToken('preview')
        setState({
          status: 'ready',
          bridge: createBrowserBridge(),
          auth: { kind: 'linked', session: previewSession() },
        })
        return
      }

      try {
        const bridge = createMessengerBridge()
        bridge.ready()
        bridge.expand()

        const auth = await authenticate(
          bridge.platform,
          bridge.getInitData(),
          bridge.getStartParam(),
        )
        setState({ status: 'ready', bridge, auth })
      } catch (error) {
        setState({
          status: 'ready',
          bridge: createBrowserBridge(),
          auth: {
            kind: 'error',
            message: error instanceof Error ? error.message : 'Не удалось запустить mini app',
          },
        })
      }
    }

    void run()
  }, [])

  return state
}
